/* Thanh lọc trang collection — snippets/collection-filter-bar.liquid (layout theo lamourbrilliance).
   Chỉ nạp ở sections/main-collection.liquid, thay cho section-main-collection.js cũ.

   Thanh lọc nằm trong #CollectionProductGrid: mỗi lần lọc/sắp xếp ta fetch lại section
   (?section_id=) rồi thay innerHTML của #CollectionProductGrid, nên trạng thái active, chip,
   số đếm luôn do server dựng theo URL. Vì DOM bị thay, mọi sự kiện đều delegation trên document;
   chỉ rail (đo tràn ngang) phải đo lại sau mỗi lần render.

   Hành vi giống lamour:
   - Tab + ô ở hàng icon ngoài: bấm là lọc ngay.
   - Drawer: chọn rồi bấm Apply; đóng mà không Apply thì trả lại lựa chọn cũ (data-checked).
   - Sort: dropdown, chọn là sắp xếp ngay. */
(function () {
  'use strict';

  var requestId = 0;
  var abortController = null;
  var lastSearch = window.location.search;
  var openSortEl = null;
  var lastTrigger = null;

  function barEl() {
    return document.querySelector('[data-knt-cf]');
  }

  function gridEl() {
    return document.getElementById('CollectionProductGrid');
  }

  function drawerEl() {
    return document.querySelector('[data-knt-cf-drawer]');
  }

  function sectionId() {
    var section = document.querySelector('[data-section-type="collection"]');
    return section ? section.getAttribute('data-section-id') : null;
  }

  function currentParams() {
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    return params;
  }

  function isShown(el) {
    return el.getClientRects().length > 0;
  }

  /* ---------- Render AJAX ---------- */

  function render(params, push) {
    params = new URLSearchParams(params);
    params.delete('section_id');
    var query = params.toString();
    var pageUrl = window.location.pathname + (query ? '?' + query : '');
    var grid = gridEl();
    var id = sectionId();

    if (!grid || !id) {
      window.location.href = pageUrl;
      return;
    }

    var fetchParams = new URLSearchParams(query);
    fetchParams.set('section_id', id);

    requestId += 1;
    var current = requestId;
    if (abortController) abortController.abort();
    abortController = window.AbortController ? new AbortController() : null;

    closeSort();
    grid.classList.add('knt-cf-loading');

    fetch(window.location.pathname + '?' + fetchParams.toString(), abortController ? { signal: abortController.signal } : undefined)
      .then(function (response) {
        if (!response.ok) throw new Error('Filter request failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        if (current !== requestId) return;
        var next = new DOMParser().parseFromString(html, 'text/html').getElementById('CollectionProductGrid');
        if (!next) throw new Error('Filter response has no #CollectionProductGrid');

        var railScroll = saveRailScroll();
        unlockPage();
        grid.innerHTML = next.innerHTML;
        grid.classList.remove('knt-cf-loading');

        if (push) history.pushState({ kntCf: true }, '', pageUrl);
        lastSearch = window.location.search;
        afterRender(railScroll);
      })
      .catch(function (error) {
        if (error.name === 'AbortError' || current !== requestId) return;
        console.error(error);
        // Lỗi mạng/section: chuyển trang thường để khách không kẹt ở trạng thái loading.
        window.location.href = pageUrl;
      });
  }

  function afterRender(railScroll) {
    initRails(railScroll);
    syncEmptyMessage();
    requestStickyUpdate();

    if (window.WAU) {
      if (WAU.Quickshop && typeof WAU.Quickshop.init === 'function') WAU.Quickshop.init();
      if (WAU.ProductGridVideo && typeof WAU.ProductGridVideo.init === 'function') WAU.ProductGridVideo.init();
    }

    document.dispatchEvent(new CustomEvent('knt-cf:rendered'));
  }

  // Thông báo khi lưới trống: đang lọc thì gợi ý bớt filter, còn không thì là collection trống.
  function syncEmptyMessage() {
    var filterMsg = document.querySelector('.js-coll-empty-filter');
    var emptyMsg = document.querySelector('.js-coll-empty');
    if (!filterMsg || !emptyMsg) return;

    var filtering = false;
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (key.indexOf('filter.') === 0) filtering = true;
    });
    filterMsg.style.display = filtering ? 'block' : 'none';
    emptyMsg.style.display = filtering ? 'none' : 'block';
  }

  // Một ô có thể đại diện nhiều giá trị gốc chỉ khác hoa/thường ("14k Rose Gold" / "14K Rose Gold").
  function valuesOf(el) {
    var raw = el.getAttribute('data-values');
    return raw ? raw.split('||') : [el.value];
  }

  function removeValues(params, name, values) {
    var kept = params.getAll(name).filter(function (value) {
      return values.indexOf(value) === -1;
    });
    params.delete(name);
    kept.forEach(function (value) { params.append(name, value); });
  }

  /* ---------- Link: tab, chip, Clear all ---------- */

  function followLink(link) {
    if (link.hasAttribute('data-knt-cf-clear-all')) {
      // Giữ tab đang chọn và kiểu sắp xếp — như lamour, tab là "collection con" chứ không phải filter.
      var keep = (barEl() && barEl().getAttribute('data-tabs-param')) || '';
      var params = currentParams();
      var keys = [];
      params.forEach(function (value, key) {
        if (key.indexOf('filter.') === 0 && key !== keep && keys.indexOf(key) === -1) keys.push(key);
      });
      keys.forEach(function (key) { params.delete(key); });
      render(params, true);
      return;
    }

    if (link.hasAttribute('data-values')) {
      var chipParams = currentParams();
      removeValues(chipParams, link.getAttribute('data-param'), valuesOf(link));
      render(chipParams, true);
      return;
    }

    var url = new URL(link.href, window.location.origin);
    url.searchParams.delete('page');
    render(url.searchParams, true);
  }

  /* ---------- Link sang collection shape khác (trang {shape}-cut-engagement-rings) ---------- */

  // Chuyển hẳn trang (khác collection, có thể khác template nên không render AJAX được),
  // giữ lại Style / tab / sort đang chọn, bỏ filter shape và số trang.
  function followShapeNav(link) {
    var params = currentParams();
    params.delete('filter.p.m.custom.shape');
    var query = params.toString();
    window.location.href = link.getAttribute('href') + (query ? '?' + query : '');
  }

  /* ---------- Hàng icon ngoài: lọc ngay ---------- */

  function onInlineChange(input) {
    var tile = input.closest('[data-knt-cf-tile]');
    if (tile) tile.classList.toggle('is-active', input.checked);

    var params = currentParams();
    var values = valuesOf(input);
    removeValues(params, input.name, values);
    if (input.checked) values.forEach(function (value) { params.append(input.name, value); });
    render(params, true);
  }

  /* ---------- Rail cuộn ngang ---------- */

  function railParts(rail) {
    return {
      viewport: rail.querySelector('[data-knt-cf-rail-viewport]'),
      prev: rail.querySelector('[data-knt-cf-rail-nav="-1"]'),
      next: rail.querySelector('[data-knt-cf-rail-nav="1"]'),
      items: rail.querySelectorAll('.knt-cf__item')
    };
  }

  function updateRail(rail) {
    var parts = railParts(rail);
    if (!parts.viewport || !parts.items.length) return;

    // Đo bề rộng thật của các ô (ul có min-width 100% nên không đo ul được), so với cả rail.
    var first = parts.items[0];
    var last = parts.items[parts.items.length - 1];
    var contentWidth = last.offsetLeft + last.offsetWidth - first.offsetLeft;
    var overflowing = contentWidth - rail.clientWidth > 2;
    rail.classList.toggle('is-overflowing', overflowing);

    var maxScroll = Math.max(0, parts.viewport.scrollWidth - parts.viewport.clientWidth);
    var left = parts.viewport.scrollLeft;
    var atStart = !overflowing || left <= 8;
    var atEnd = !overflowing || left >= maxScroll - 8;

    if (parts.prev) {
      parts.prev.disabled = atStart;
      parts.prev.setAttribute('aria-hidden', overflowing ? 'false' : 'true');
    }
    if (parts.next) {
      parts.next.disabled = atEnd;
      parts.next.setAttribute('aria-hidden', overflowing ? 'false' : 'true');
    }
  }

  // Ô đang chọn bị khuất thì cuộn cho nó lọt vào khung (lamour làm vậy khi tải trang).
  function revealActive(rail) {
    var parts = railParts(rail);
    var active = rail.querySelector('[data-knt-cf-input]:checked, [data-knt-cf-shape-nav].is-active');
    if (!active || !parts.viewport) return;
    var item = active.closest('.knt-cf__item');
    var viewport = parts.viewport;
    var itemLeft = item.offsetLeft - viewport.firstElementChild.offsetLeft;
    var itemRight = itemLeft + item.offsetWidth;
    if (itemLeft < viewport.scrollLeft) {
      viewport.scrollLeft = itemLeft;
    } else if (itemRight > viewport.scrollLeft + viewport.clientWidth) {
      viewport.scrollLeft = itemRight - viewport.clientWidth;
    }
  }

  function saveRailScroll() {
    var saved = {};
    document.querySelectorAll('[data-knt-cf-rail]').forEach(function (rail) {
      var viewport = rail.querySelector('[data-knt-cf-rail-viewport]');
      if (viewport) saved[rail.getAttribute('data-knt-cf-rail')] = viewport.scrollLeft;
    });
    return saved;
  }

  // Đo lại khi kích thước rail đổi mà không có resize cửa sổ: font tải xong, CSS đổi
  // (theme dev hot-reload), cột grid co giãn… — nếu không, class is-overflowing bị kẹt.
  var pendingRails = [];
  var railFrame = null;
  var railObserver = window.ResizeObserver ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var rail = entry.target.closest('[data-knt-cf-rail]');
      if (rail && pendingRails.indexOf(rail) === -1) pendingRails.push(rail);
    });
    if (railFrame) return;
    railFrame = window.requestAnimationFrame(function () {
      railFrame = null;
      var rails = pendingRails;
      pendingRails = [];
      rails.forEach(function (rail) {
        if (document.contains(rail)) updateRail(rail);
      });
    });
  }) : null;

  function initRails(saved) {
    if (railObserver) railObserver.disconnect();
    document.querySelectorAll('[data-knt-cf-rail]').forEach(function (rail) {
      if (railObserver) {
        railObserver.observe(rail);
        var content = rail.querySelector('.knt-cf__rail-items');
        if (content) railObserver.observe(content);
      }
      updateRail(rail);
      var key = rail.getAttribute('data-knt-cf-rail');
      var viewport = rail.querySelector('[data-knt-cf-rail-viewport]');
      if (saved && saved[key] != null && viewport) {
        // Sau khi lọc giữ nguyên vị trí cuộn, khỏi nhảy về đầu.
        viewport.scrollLeft = saved[key];
      } else {
        revealActive(rail);
      }
      updateRail(rail);
    });
  }

  function scrollRail(button) {
    var rail = button.closest('[data-knt-cf-rail]');
    var viewport = rail && rail.querySelector('[data-knt-cf-rail-viewport]');
    if (!viewport) return;
    var direction = Number(button.getAttribute('data-knt-cf-rail-nav')) || 1;
    var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    var left = Math.max(0, Math.min(maxScroll, viewport.scrollLeft + viewport.clientWidth * direction));
    viewport.scrollTo({ left: left, behavior: 'smooth' });
  }

  var resizeFrame = null;
  window.addEventListener('resize', function () {
    if (resizeFrame) return;
    resizeFrame = window.requestAnimationFrame(function () {
      resizeFrame = null;
      document.querySelectorAll('[data-knt-cf-rail]').forEach(updateRail);
    });
  });

  // scroll không nổi bọt nên bắt ở pha capture.
  document.addEventListener('scroll', function (event) {
    var target = event.target;
    if (target && target.nodeType === 1 && target.matches('[data-knt-cf-rail-viewport]')) {
      updateRail(target.closest('[data-knt-cf-rail]'));
    }
  }, true);

  /* ---------- Nút Filters nổi (mobile) ---------- */

  // Như lamour: chỉ hiện khi nút Filters gốc đã khuất khỏi màn hình và đáy màn hình vẫn còn nằm
  // trong section collection (lướt tới footer thì ẩn). Bấm nút = data-knt-cf-open, mở drawer.
  var mobileQuery = window.matchMedia('(max-width: 768px)');
  var stickyFrame = null;

  function updateStickyFilter() {
    stickyFrame = null;
    var sticky = document.querySelector('[data-knt-cf-sticky]');
    if (!sticky) return;
    var trigger = document.querySelector('.knt-cf__filters-trigger');
    var section = document.querySelector('[data-section-type="collection"]');
    var show = false;
    if (mobileQuery.matches && trigger && section) {
      var sectionRect = section.getBoundingClientRect();
      var triggerRect = trigger.getBoundingClientRect();
      var inSection = sectionRect.top < window.innerHeight && sectionRect.bottom > window.innerHeight;
      var triggerHidden = triggerRect.bottom <= 0 || triggerRect.top >= window.innerHeight;
      show = inSection && triggerHidden;
    }
    sticky.classList.toggle('is-visible', show);
  }

  function requestStickyUpdate() {
    if (!stickyFrame) stickyFrame = window.requestAnimationFrame(updateStickyFilter);
  }

  window.addEventListener('scroll', requestStickyUpdate, { passive: true });
  window.addEventListener('resize', requestStickyUpdate);

  /* ---------- Sort ---------- */

  function openSort(sort) {
    closeSort();
    var trigger = sort.querySelector('[data-knt-cf-sort-trigger]');
    var menu = sort.querySelector('.knt-cf__sort-menu');
    if (!trigger || !menu) return;
    menu.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    sort.classList.add('is-open');
    openSortEl = sort;
  }

  function closeSort(restoreFocus) {
    if (!openSortEl) return;
    var trigger = openSortEl.querySelector('[data-knt-cf-sort-trigger]');
    var menu = openSortEl.querySelector('.knt-cf__sort-menu');
    if (menu) menu.hidden = true;
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) trigger.focus();
    }
    openSortEl.classList.remove('is-open');
    openSortEl = null;
  }

  function selectSort(option) {
    var sort = option.closest('[data-knt-cf-sort]');
    var label = sort && sort.querySelector('[data-knt-cf-sort-trigger] span');
    if (label) label.textContent = option.textContent.trim();
    sort.querySelectorAll('[data-knt-cf-sort-option]').forEach(function (item) {
      item.setAttribute('aria-selected', item === option ? 'true' : 'false');
    });
    closeSort();

    var params = currentParams();
    params.set('sort_by', option.getAttribute('data-value'));
    render(params, true);
  }

  /* ---------- Drawer ---------- */

  function lockPage() {
    document.documentElement.classList.add('knt-cf-open');
  }

  function unlockPage() {
    document.documentElement.classList.remove('knt-cf-open');
  }

  function priceInputs(group) {
    return {
      min: group.querySelector('[data-knt-cf-price-min]'),
      max: group.querySelector('[data-knt-cf-price-max]'),
      sliderMin: group.querySelector('[data-knt-cf-slider-min]'),
      sliderMax: group.querySelector('[data-knt-cf-slider-max]'),
      rangeMax: Number(group.getAttribute('data-range-max')) || 0
    };
  }

  function priceActive(group) {
    var price = priceInputs(group);
    var min = Number(price.min.value);
    var max = price.max.value === '' ? price.rangeMax : Number(price.max.value);
    return min > 0 || max < price.rangeMax;
  }

  // Đồng bộ 2 ô số với 2 thanh trượt (thanh trượt không có name, chỉ để kéo cho tiện).
  function syncPrice(group, source) {
    var price = priceInputs(group);
    if (source === price.sliderMin || source === price.sliderMax) {
      var low = Number(price.sliderMin.value);
      var high = Number(price.sliderMax.value);
      if (low > high) {
        var swap = low;
        low = high;
        high = swap;
      }
      price.min.value = low > 0 ? low : '';
      price.max.value = high < price.rangeMax ? high : '';
    } else {
      price.sliderMin.value = price.min.value === '' ? 0 : price.min.value;
      price.sliderMax.value = price.max.value === '' ? price.rangeMax : price.max.value;
    }
  }

  // Cập nhật ô active, dòng ": giá trị" của tiêu đề nhóm (mobile) và "Filters Selected N".
  function syncDrawer(drawer) {
    var count = 0;
    drawer.querySelectorAll('[data-knt-cf-group]').forEach(function (group) {
      var labels = [];
      var selected = 0;

      if (group.hasAttribute('data-knt-cf-price')) {
        if (priceActive(group)) selected = 1;
      } else {
        group.querySelectorAll('[data-knt-cf-input]').forEach(function (input) {
          var tile = input.closest('[data-knt-cf-tile]');
          if (tile) tile.classList.toggle('is-active', input.checked);
          if (input.checked) labels.push(input.getAttribute('data-label'));
        });
        selected = labels.length;
      }

      var valueEl = group.querySelector('[data-knt-cf-group-value]');
      if (valueEl) valueEl.textContent = labels.length ? ': ' + labels.join(', ') : '';
      if (isShown(group)) count += selected;
    });

    var summary = drawer.querySelector('[data-knt-cf-summary]');
    if (summary) summary.textContent = (summary.getAttribute('data-label') || '__COUNT__').replace('__COUNT__', count);
  }

  // Trả drawer về đúng trạng thái đang áp dụng (bỏ lựa chọn chưa Apply).
  function resetDrawer(drawer) {
    drawer.querySelectorAll('[data-knt-cf-input]').forEach(function (input) {
      input.checked = input.getAttribute('data-checked') === 'true';
    });
    drawer.querySelectorAll('[data-knt-cf-price]').forEach(function (group) {
      var price = priceInputs(group);
      price.min.value = price.min.getAttribute('data-committed') || '';
      price.max.value = price.max.getAttribute('data-committed') || '';
      syncPrice(group, price.min);
    });
    syncDrawer(drawer);
  }

  function openDrawer(trigger) {
    var drawer = drawerEl();
    if (!drawer) return;
    closeSort();
    resetDrawer(drawer);
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockPage();
    lastTrigger = trigger || null;
    document.querySelectorAll('[data-knt-cf-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'true');
    });
    // Đếm lại sau khi drawer hiện, vì nhóm ẩn/hiện theo breakpoint.
    syncDrawer(drawer);
    var close = drawer.querySelector('.knt-cf__drawer-close');
    if (close) close.focus({ preventScroll: true });
  }

  function closeDrawer(options) {
    var drawer = drawerEl();
    if (!drawer || !drawer.classList.contains('is-open')) return;
    options = options || {};
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockPage();
    document.querySelectorAll('[data-knt-cf-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
    if (options.reset !== false) resetDrawer(drawer);
    if (options.restoreFocus && lastTrigger && document.contains(lastTrigger)) {
      lastTrigger.focus({ preventScroll: true });
    }
  }

  function clearDrawer() {
    var drawer = drawerEl();
    if (!drawer) return;
    drawer.querySelectorAll('[data-knt-cf-group]').forEach(function (group) {
      if (!isShown(group)) return;
      if (group.hasAttribute('data-knt-cf-price')) {
        var price = priceInputs(group);
        price.min.value = '';
        price.max.value = '';
        syncPrice(group, price.min);
      } else {
        group.querySelectorAll('[data-knt-cf-input]').forEach(function (input) {
          input.checked = false;
        });
      }
    });
    syncDrawer(drawer);
  }

  // Ghép URL từ URL hiện tại: nhóm nào đang hiện trong drawer thì thay toàn bộ giá trị của nhóm đó
  // (desktop không đụng tới Style/Shape vì 2 nhóm này nằm ở hàng icon ngoài).
  function applyDrawer() {
    var drawer = drawerEl();
    if (!drawer) return;
    var params = currentParams();

    drawer.querySelectorAll('[data-knt-cf-group]').forEach(function (group) {
      if (!isShown(group)) return;

      if (group.hasAttribute('data-knt-cf-price')) {
        var price = priceInputs(group);
        var minName = group.getAttribute('data-min-name');
        var maxName = group.getAttribute('data-max-name');
        params.delete(minName);
        params.delete(maxName);
        var min = Number(price.min.value);
        var max = Number(price.max.value);
        if (price.min.value !== '' && min > 0) params.set(minName, min);
        if (price.max.value !== '' && max < price.rangeMax) params.set(maxName, max);
        return;
      }

      var name = group.getAttribute('data-param');
      params.delete(name);
      group.querySelectorAll('[data-knt-cf-input]:checked').forEach(function (input) {
        valuesOf(input).forEach(function (value) { params.append(name, value); });
      });
    });

    closeDrawer({ reset: false });
    if (params.toString() === currentParams().toString()) return;
    render(params, true);
  }

  /* ---------- Sự kiện ---------- */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;

    var shapeNav = target.closest('[data-knt-cf-shape-nav]');
    if (shapeNav) {
      event.preventDefault();
      if (!shapeNav.classList.contains('is-active')) followShapeNav(shapeNav);
      return;
    }

    var link = target.closest('[data-knt-cf-link]');
    if (link) {
      event.preventDefault();
      followLink(link);
      return;
    }

    var openTrigger = target.closest('[data-knt-cf-open]');
    if (openTrigger) {
      event.preventDefault();
      var drawer = drawerEl();
      if (drawer && drawer.classList.contains('is-open')) closeDrawer({ restoreFocus: true });
      else openDrawer(openTrigger);
      return;
    }

    if (target.closest('[data-knt-cf-close]')) {
      event.preventDefault();
      closeDrawer({ restoreFocus: true });
      return;
    }

    if (target.closest('[data-knt-cf-clear]')) {
      event.preventDefault();
      clearDrawer();
      return;
    }

    if (target.closest('[data-knt-cf-apply]')) {
      event.preventDefault();
      applyDrawer();
      return;
    }

    var railNav = target.closest('[data-knt-cf-rail-nav]');
    if (railNav) {
      event.preventDefault();
      scrollRail(railNav);
      return;
    }

    var sortTrigger = target.closest('[data-knt-cf-sort-trigger]');
    if (sortTrigger) {
      event.preventDefault();
      var sort = sortTrigger.closest('[data-knt-cf-sort]');
      if (openSortEl === sort) closeSort();
      else openSort(sort);
      return;
    }

    var sortOption = target.closest('[data-knt-cf-sort-option]');
    if (sortOption) {
      event.preventDefault();
      selectSort(sortOption);
      return;
    }

    // Bấm ra ngoài thì đóng dropdown sort / drawer (desktop không có overlay, giống lamour).
    if (openSortEl && !openSortEl.contains(target)) closeSort();
    var openDrawerEl = document.querySelector('[data-knt-cf-drawer].is-open');
    if (openDrawerEl && !openDrawerEl.contains(target)) closeDrawer();
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-knt-cf-input]')) return;
    if (input.closest('[data-knt-cf-inline]')) {
      onInlineChange(input);
    } else if (input.closest('[data-knt-cf-drawer]')) {
      syncDrawer(input.closest('[data-knt-cf-drawer]'));
    }
  });

  document.addEventListener('input', function (event) {
    var group = event.target.closest && event.target.closest('[data-knt-cf-price]');
    if (!group) return;
    syncPrice(group, event.target);
    syncDrawer(group.closest('[data-knt-cf-drawer]'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (openSortEl) {
      closeSort(true);
      return;
    }
    closeDrawer({ restoreFocus: true });
  });

  window.addEventListener('popstate', function () {
    if (!barEl() || window.location.search === lastSearch) return;
    lastSearch = window.location.search;
    render(new URLSearchParams(window.location.search), false);
  });

  function init() {
    if (!barEl()) return;
    lastSearch = window.location.search;
    initRails();
    syncEmptyMessage();
    requestStickyUpdate();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
